import React from 'react';

import { pipe } from '@code-expert/prelude';
import { concatRoutes, parser } from '/imports/modules/Routing';
import { Authorise, AuthorisePublic } from '/imports/ui/components/Authorise';
import { TopNavLayout } from '/imports/ui/layouts/TopNavLayout';
import {
  examLoginRoute,
  examLoginUseCaseRoute,
  examLogoutRoute,
  examReviewRoute,
  examRoute,
  examStudentRoute,
} from '/imports/ui/pages/exam/routes';

const LoginExam = React.lazy(() => import('/imports/ui/pages/login/LoginExam'));
const LogoutExam = React.lazy(() => import('/imports/ui/pages/logout/LogoutExam'));
const ExamRoutes = React.lazy(() => import('/imports/ui/pages/examStudent/ExamRoutes'));
const ExamReview = React.lazy(() => import('/imports/ui/pages/examReview/ExamReview'));
const ExamStudent = React.lazy(() => import('/imports/ui/pages/examStudent/ExamStudent'));

export const examRouter = concatRoutes([
  pipe(
    examLoginRoute.parser,
    parser.map(({ examId, accessToken }) => (
      <AuthorisePublic
        deny={['exam', 'lti']}
        layout={(children) => (
          <TopNavLayout selected="none" disableLogin>
            {children}
          </TopNavLayout>
        )}
      >
        <LoginExam examId={examId} accessToken={accessToken} />
      </AuthorisePublic>
    )),
  ),
  pipe(
    examLoginUseCaseRoute.parser,
    parser.map(({ examId, accessToken, useCase }) => (
      <AuthorisePublic
        deny={['exam', 'lti']}
        layout={(children) => (
          <TopNavLayout selected="none" disableLogin>
            {children}
          </TopNavLayout>
        )}
      >
        <LoginExam examId={examId} accessToken={accessToken} useCase={useCase} />
      </AuthorisePublic>
    )),
  ),
  pipe(
    examRoute.parser,
    parser.map(({ examId, accessToken }) => (
      <AuthorisePublic
        deny={['exam', 'lti']}
        layout={(children) => (
          <TopNavLayout selected="none" disableLogin>
            {children}
          </TopNavLayout>
        )}
      >
        <ExamRoutes examId={examId} accessToken={accessToken} />
      </AuthorisePublic>
    )),
  ),
  pipe(
    examReviewRoute.parser,
    parser.map(({ examId, accessToken }) => (
      <Authorise
        allow={['login']}
        layout={(children) => <TopNavLayout selected="none">{children}</TopNavLayout>}
      >
        <ExamReview examId={examId} accessToken={accessToken} />
      </Authorise>
    )),
  ),
  pipe(
    examStudentRoute.parser,
    parser.map(({ examId }) => (
      <Authorise
        allow={['exam']}
        layout={(children) => <TopNavLayout selected="none">{children}</TopNavLayout>}
      >
        <ExamStudent examId={examId} />
      </Authorise>
    )),
  ),
  pipe(
    examLogoutRoute.parser,
    parser.map(() => <LogoutExam />),
  ),
]);
